import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";

const VaultsPage = lazy(() => import("./pages/VaultsPage/VaultsPage"));
const VaultPage = lazy(() => import("./pages/VaultPage/VaultPage"));

export const vaultModule: FrontModule = {
  id: "vault",
  version: "0.1.0",
  permission: "vault.read",
  label: "Vault",
  icon: "lock",
  description: "Store and share the company's passwords securely, only with the people who need them.",
  routes: [
    { path: "/vault", Component: VaultsPage },
    { path: "/vault/:vaultId", Component: VaultPage },
  ],
  menu: [
    {
      id: "vault.vaults",
      label: "Vaults",
      icon: "lock",
      path: "/vault",
      permission: "vault.read",
      description: "The vaults you share with your team",
    },
  ],
};

export default vaultModule;
